<template>
  <div class="notice_page">
    <NoticeSearch @searchNotice="searchNotice"></NoticeSearch>
    <div class="notice_box">
      <div class="notice_content content_auto">
        <h2>{{ $t('公告中心') }}</h2>
        <p class="notice_tips">{{ $t('消息列表') }}</p>
        <div v-if="noticeList.length > 0">
          <ul>
            <li v-for="(item, index) in noticeList" :key="index">
              <h3>{{ item.title }}</h3>
              <!-- <VClamp tag="p" class="content" :max-lines="2">{{ item.content }}</VClamp> -->
              <p v-html="dealContent(item.content, 160)" class="content"></p>
              <p class="time">{{ item.createTime }}</p>
              <span @click="jumpTo('/noticeDetail', { id: item.id })">{{
                $t('详情')
              }}</span>
            </li>
          </ul>
          <Pagination
            class="page_box"
            v-show="total > 0"
            :total="total"
            layout="prev, pager, next"
            :page.sync="listQuery.currentPage"
            :limit.sync="listQuery.pageSize"
            @pagination="getNoticeList"
          ></Pagination>
        </div>
        <NoData v-else height="200px" sceneType="day"></NoData>
      </div>
    </div>
  </div>
</template>
<script>
import NoticeSearch from './components/NoticeSearch'
import { noticeList } from '@/api/notice'
export default {
  components: {
    NoticeSearch
  },
  data() {
    return {
      noticeList: [], // 公告列表
      total: 0,
      listQuery: {
        start: 0,
        offset: 5,
        type: 'Notice'
      }
    }
  },
  created() {
    if (this.$route.query.tag === 'isDetail') {
      this.listQuery.title = this.$route.query.search
    }
    this.getNoticeList()
  },
  methods: {
    jumpTo(p, q) {
      this.$router.push({ path: p, query: q })
    },
    async getNoticeList() {
      try {
        const { item, count } = await noticeList(this.listQuery)
        this.total = count
        this.noticeList = item
      } catch {
        this.total = 0
        this.noticeList = []
      }
    },
    searchNotice(val) {
      this.listQuery.title = val
      this.listQuery.currentPage = 1
      this.getNoticeList()
    },
    dealContent(content, length) {
      if (!content) return
      if (content.length > length) {
        return content.slice(0, length) + '...'
      } else {
        return content
      }
    }
  }
}
</script>
<style lang="less" scoped>
.notice_page {
  .notice_box {
    overflow: hidden;
    .notice_content {
      margin-top: 40px;
      h2 {
        height: 33px;
        font-size: 24px;
        font-family: PingFangSC-Medium, 'PingFang SC';
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 33px;
      }
      .notice_tips {
        margin-top: 36px;
        padding: 10px 20px;
        border-bottom: 1px solid rgba(151, 151, 151, 1);
      }
      ul {
        padding: 10px 20px;
        li {
          margin-top: 10px;
          padding-bottom: 10px;
          position: relative;
          border-bottom: 1px solid rgba(232, 232, 232, 1);
          h3 {
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
          }
          .content {
            margin-top: 10px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 20px;
            word-break: break-all;
          }
          .time {
            margin-top: 10px;
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 20px;
          }
          span {
            position: absolute;
            top: 0px;
            right: 0px;
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(66, 179, 250, 1);
            line-height: 20px;
            cursor: pointer;
          }
        }
        li:last-child {
          border-bottom: none;
        }
      }
      .page_box {
        margin: 25px 0 75px;
      }
    }
  }
}
</style>
